import { debate } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Debate() {
  const yes = debate.data[0];
  const no = debate.data[1];
  return (
    <section id="debate" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="争议观察 · 摆出两边的道理"
          title="同一个瓜，为什么大家吃不到一块去"
          desc="争议不是非黑即白。把支持方与反对方的核心论点同时摆出来，你再来判断自己更认同哪一边。"
          align="center"
          accent
        />

        <div className="mx-auto mt-8 max-w-3xl rounded-2xl border border-background-200 bg-background-100 p-6 text-center md:p-8">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-flag-2-fill" aria-hidden="true"></i>
            {debate.badge}
          </span>
          <h2 className="mt-4 text-xl font-bold leading-snug text-foreground-950 md:text-2xl">{debate.title}</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700">{debate.summary}</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="relative overflow-hidden rounded-2xl border border-accent-200 bg-accent-50/70 p-6">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-thumb-up-line" aria-hidden="true"></i>
              {yes.camp}
            </span>
            <h3 className="mt-4 text-lg font-bold text-foreground-950">{yes.title}</h3>
            <ul className="mt-4 space-y-3">
              {yes.points.map((p) => (
                <li key={p} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-800">
                  <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-600" aria-hidden="true"></i>
                  {p}
                </li>
              ))}
            </ul>
          </div>

          <div className="relative overflow-hidden rounded-2xl border border-primary-200 bg-primary-100/60 p-6">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-thumb-down-line" aria-hidden="true"></i>
              {no.camp}
            </span>
            <h3 className="mt-4 text-lg font-bold text-foreground-950">{no.title}</h3>
            <ul className="mt-4 space-y-3">
              {no.points.map((p) => (
                <li key={p} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-800">
                  <i className="ri-close-circle-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true"></i>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-background-200 bg-background-50 p-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950">
              <i className="ri-pie-chart-2-line text-secondary-500" aria-hidden="true"></i>
              站队分布（围观者当前倾向）
            </h3>
            <a
              href="#about"
              className="inline-flex items-center whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              也来说说你的立场
              <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
            </a>
          </div>
          <div className="mt-4 flex h-3 w-full gap-1 overflow-hidden rounded-full" role="img" aria-label={debate.poll.yes + "；" + debate.poll.no + "；" + debate.poll.mid}>
            <div className="h-full rounded-l-full bg-accent-500" style={{ width: "46%" }}></div>
            <div className="h-full bg-primary-500" style={{ width: "38%" }}></div>
            <div className="h-full flex-1 rounded-r-full bg-background-300"></div>
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-foreground-700">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-blank-circle-fill text-accent-500" aria-hidden="true"></i>
              支持方 {debate.poll.yes}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-blank-circle-fill text-primary-500" aria-hidden="true"></i>
              反对方 {debate.poll.no}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-blank-circle-fill text-background-300" aria-hidden="true"></i>
              {debate.poll.mid}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}